import React, {memo, useState} from 'react';
import * as Assets from '../../assets/images/images';
import {
  NavigationItem,
  SubNavigationDropdown,
  SubNavigationItem,
} from './components';
import {usePermissions} from 'hooks/useSidbarPermissions';
import {NavLink} from 'react-router-dom';
import {apiLogsMobileNav, apiLogsNav} from '../../assets/images/images';
import {Constants} from 'helpers';
import {
  BaasOverview,
  BaasWallets,
  Developers,
  DocumentAnalysis,
  EasyOnboard,
  Logs,
  Settings,
} from 'components/images/sidebar';

const VeldroSideNavigation = memo(
  ({media, splitLocation, pathname, openDropdown, toggleSubRoute}) => {
    const {USER_PERMISSIONS} = usePermissions();
    const [hoveredDropdown, setHoveredDropdown] = useState({});

    const handleHoverChange = (dropdownKey, isHovered) => {
      setHoveredDropdown(prev => ({
        ...prev,
        [dropdownKey]: isHovered,
      }));
    };

    return (
      <>
        <div className="">
          <NavigationItem
            media={media}
            title={
              <div className="flex items-center font-inter gap-2">Overview</div>
            }
            to={Constants.PAGES_URL.VELDRO_OVERVIEW}
            IconComponent={BaasOverview}
          />
        </div>
        <div className="mt-2">
          <NavigationItem
            media={media}
            title={
              <div className="flex items-center font-inter gap-2">
                Businesses
              </div>
            }
            to={Constants.PAGES_URL.VELDRO_BUSINESSES}
            IconComponent={EasyOnboard}
          />
        </div>
        <div className="mt-2">
          <NavigationItem
            media={media}
            title={
              <div className="flex items-center font-inter gap-2">Invoices</div>
            }
            to={Constants.PAGES_URL.VELDRO_SENT_INVOICES}
            IconComponent={DocumentAnalysis}
          />
        </div>
        <div className="mt-2">
          <NavigationItem
            media={media}
            title={
              <div className="flex items-center font-inter gap-2">
                Reported Invoices
              </div>
            }
            to={Constants.PAGES_URL.VELDRO_REPORTED_INVOICES}
            IconComponent={BaasWallets}
          />
        </div>
        <div className="mt-2 flex flex-col gap-2 rounded lg:text-white text-grey">
          <SubNavigationDropdown
            media={media}
            subRoutes={[
              Constants.PAGES_URL.DEVELOPERS_API_LOGS,
              Constants.PAGES_URL.DEVELOPERS_CONFIGURATION,
              Constants.PAGES_URL.DEVELOPERS_WEBHOOK,
              Constants.PAGES_URL.API_TOKENS,
            ]}
            IconComponent={Developers}
            isChildHovered={hoveredDropdown['developers']}
            toggleSubRoute={() => toggleSubRoute('developers')}
            src={media ? Assets.developersNav : Assets.developersMobileNav}
            open={openDropdown === 'developers'}
            label="Developers"
          />

          {openDropdown === 'developers' && (
            <div className="flex flex-col">
              <SubNavigationItem
                media={media}
                title="API Logs"
                to={Constants.PAGES_URL.DEVELOPERS_API_LOGS}
                webIcon={apiLogsNav}
                mobileIcon={apiLogsMobileNav}
                inner
              />
              <SubNavigationItem
                media={media}
                title="Configuration"
                to={Constants.PAGES_URL.DEVELOPERS_CONFIGURATION}
                webIcon={Assets.configurationNav}
                mobileIcon={Assets.configurationMobileNav}
                inner
              />

              <SubNavigationItem
                media={media}
                title="Webhooks"
                to={Constants.PAGES_URL.DEVELOPERS_WEBHOOK}
                webIcon={Assets.webhookNav}
                mobileIcon={Assets.webhookMobileNav}
                inner
              />
              <a
                href="http://docs.veldro.com/"
                target="_blank"
                rel="noreferrer"
                className={`rounded-b-lg lg:text-[#0e122a] text-grey hover:bg-[#d4b8e0] flex items-center h-[38px] bg-[#f2e6f7] gap-2 pl-8 lg:pl-[38px] pr-2 py-2 relative ${splitLocation[1]} === "" ? "active" : ""`}
              >
                <span className="text-sm lg:text-[#0e122a] text-grey -mb-1 mr-[7px]">
                  Documentation
                </span>
                <img src={Assets.hyperLinkGrey} alt="" width={14} height={14} />
              </a>
            </div>
          )}
        </div>
        <div className="mt-2">
          <NavigationItem
            media={media}
            title={
              <div className="flex items-center font-inter gap-2">Logs</div>
            }
            active={
              pathname === Constants.PAGES_URL.AUDIT_LOGS ||
              pathname === Constants.PAGES_URL.EXPORT_LOGS
            }
            to={Constants.PAGES_URL.AUDIT_LOGS}
            IconComponent={Logs}
          />
        </div>
        <div className="flex flex-col mt-2">
          <SubNavigationDropdown
            media={media}
            toggleSubRoute={() => toggleSubRoute('settings')}
            isChildHovered={hoveredDropdown['settings']}
            subRoutes={[
              Constants.PAGES_URL.SETTINGS_PROFILE,
              Constants.PAGES_URL.SETTINGS_COMPANY_VERIFICATION,
              Constants.PAGES_URL.SETTINGS_ORGANISATION,
              Constants.PAGES_URL.SETTINGS_TEAM,
            ]}
            IconComponent={Settings}
            open={openDropdown === 'settings'}
            label="Settings"
          />

          {openDropdown === 'settings' && (
            <>
              <NavLink
                to={Constants.PAGES_URL.SETTINGS_PROFILE}
                className={`nav-item rounded flex lg:hidden items-center gap-2 pl-8 py-2 relative ${splitLocation[1]} === "" ? "active" : ""`}
                aria-current="page"
              >
                <img
                  src={Assets.settingsMobileNav}
                  alt=""
                  width={18}
                  height={18}
                />
                <span className="-mb-1 text-sm text-body">All settings</span>
              </NavLink>
              <div className="flex-col hidden lg:flex">
                <SubNavigationItem
                  media={media}
                  title="Profile"
                  onHoverChange={isHovered =>
                    handleHoverChange('settings', isHovered)
                  }
                  to={Constants.PAGES_URL.SETTINGS_PROFILE}
                  webIcon={Assets.profileNav}
                  mobileIcon={Assets.settingsMobileNav}
                  inner
                />

                {USER_PERMISSIONS?.role === 'Owner' && (
                  <SubNavigationItem
                    media={media}
                    title="Company Verification"
                    className="rounded-b-lg"
                    onHoverChange={isHovered =>
                      handleHoverChange('settings', isHovered)
                    }
                    to={Constants.PAGES_URL.SETTINGS_COMPANY_VERIFICATION}
                    webIcon={Assets.auditLogsNav}
                    mobileIcon={Assets.verifyIc}
                    inner
                  />
                )}
              </div>
            </>
          )}
        </div>
      </>
    );
  },
);

export default VeldroSideNavigation;
